export default __webpack_public_path__ + "media/bradescosaude_320px_115px-15.png";